import { toCamelCase, categorizeDifficulty } from './stringUtils';
import { applyFilters } from './filterUtils';

export function getValidOptionsSet(filterType, rowsFilteredByVenueSearch, filters) {
  const otherFilters = { ...filters };
  delete otherFilters[filterType];

  const baseRows = rowsFilteredByVenueSearch;
  const relevantRows = applyFilters(baseRows, otherFilters);

  switch (filterType) {
    case 'group':
      return new Set(relevantRows.map(row => toCamelCase(row.groupName)));
    case 'location':
      if (!filters.group || filters.group.length === 0) {
        return new Set(relevantRows.map(row => row.venue).filter(Boolean));
      } else {
        return new Set(
          relevantRows
            .filter(row => filters.group.includes(toCamelCase(row.groupName)))
            .map(row => row.venue)
            .filter(Boolean)
        );
      }
    case 'availability': {
      const validAvail = new Set();
      relevantRows.forEach(row => {
        if (row.waitlistUserCount > 0) validAvail.add('Has Waitlist');
        if (parseInt(row.freeSlots, 10) > 0) validAvail.add('No waitlist');
      });
      return validAvail;
    }
    case 'difficulty': {
      const difficulties = new Set();
      relevantRows.forEach(row => {
        const cats = categorizeDifficulty(row.difficulty || '');
        if (Array.isArray(cats)) {
          cats.forEach(cat => difficulties.add(cat));
        } else if (cats) {
          difficulties.add(cats);
        }
      });
      return difficulties;
    }
    case 'dayOfWeek':
      return new Set(
        relevantRows.map(row =>
          new Date(row.startDate).toLocaleDateString('en-US', { weekday: 'long' })
        )
      );
    case 'dates':
      return new Set(relevantRows.map(row => row.startDate));
    default:
      return new Set();
  }
}

export function getGroupCounts(rowsFilteredByVenueSearch, filters) {
  const counts = {};
  const otherFilters = { ...filters };
  delete otherFilters.group;
  const relevantRows = applyFilters(rowsFilteredByVenueSearch, otherFilters);
  relevantRows.forEach(row => {
    const groupName = toCamelCase(row.groupName);
    counts[groupName] = (counts[groupName] || 0) + 1;
  });
  return counts;
}

export function getLocationCounts(rowsFilteredByVenueSearch, filters) {
  const counts = {};
  const otherFilters = { ...filters };
  delete otherFilters.location;
  const relevantRows = applyFilters(rowsFilteredByVenueSearch, otherFilters);
  relevantRows.forEach(row => {
    if (row.venue) {
      counts[row.venue] = (counts[row.venue] || 0) + 1;
    }
  });
  return counts;
}

export function getAllGroupNames(rows) {
  return Array.from(new Set(rows.map(row => toCamelCase(row.groupName)))).sort();
}

export function getAllVenues(rows) {
  return Array.from(new Set(rows.map(row => row.venue).filter(Boolean))).sort();
}
